/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configure an action on a transition.
 * 
 * The action name is gated by the same two-layer registry check the admin uses, against the
 * owner of the transition's workflow.
 * @export
 * @interface TransitionActionWriteRequest
 */
export interface TransitionActionWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof TransitionActionWriteRequest
     */
    transition: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionActionWriteRequest
     */
    actionName: string;
}

/**
 * Check if a given object implements the TransitionActionWriteRequest interface.
 */
export function instanceOfTransitionActionWriteRequest(value: object): value is TransitionActionWriteRequest {
    if (!('transition' in value) || value['transition'] === undefined) return false;
    if ((!('actionName' in (value as Record<string, any>)) && !('action_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionName'] === undefined && (value as Record<string, any>)['action_name'] === undefined)) return false;
    return true;
}

export function TransitionActionWriteRequestFromJSON(json: any): TransitionActionWriteRequest {
    return TransitionActionWriteRequestFromJSONTyped(json, false);
}

export function TransitionActionWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransitionActionWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transition': json['transition'],
        'actionName': json['action_name'],
    };
}

export function TransitionActionWriteRequestToJSON(json: any): TransitionActionWriteRequest {
    return TransitionActionWriteRequestToJSONTyped(json, false);
}

export function TransitionActionWriteRequestToJSONTyped(value?: TransitionActionWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition': value['transition'],
        'action_name': value['actionName'],
    };
}

